import Aboutus from "../Shared/AboutUs";
import Banner from "./Banner";
import BreatheEasy from "./BreatheEasy";
// import CompanyHighlights from "./CompanyHighlights";
import ConnectWithUs from "./ConnectWithUs";
import CustomerFeedback from "../Shared/CustomerFeedback";
import FAQs from "../Shared/FAQs";
import Layout from "../Shared/Layout";
import OurHVACService from "./OurHVACService";
import QualityBrands from "./QualityBrands";
import WhyChooseUs from "./WhyChooseUs";
import { useEffect, useState } from "react";
import OverLay from "./OverLay";


const Home = () => {
    const [showAppointmentSidebar, setShowAppointmentSidebar] = useState(false);
    const [activeTab, setActiveTab] = useState();

    useEffect(() => {
        const bookAppointment = sessionStorage.getItem("current_page_url");

        if (bookAppointment === "Book-Appointment") {
            setShowAppointmentSidebar(true);
            setActiveTab("book-appointment");

            // Remove so it runs only once
            // sessionStorage.removeItem("current_page_url");
        } else if (bookAppointment === "Contact-Us") {
            setShowAppointmentSidebar(true);
            setActiveTab("contact-us");
        }
    }, []);

    return (
        <Layout>
            <Banner />
            <Aboutus />
            {/* <CompanyHighlights /> */}
            <BreatheEasy />
            <OurHVACService />
            <WhyChooseUs />
            <ConnectWithUs />
            <QualityBrands />
            <FAQs />
            <CustomerFeedback />

            <OverLay
                showAppointmentSidebar={showAppointmentSidebar}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                setShowAppointmentSidebar={setShowAppointmentSidebar}

            />
        </Layout>

    )
}

export default Home;